import React from "react";
import { CloseIcon } from "../../../assets/icons";
import FileDisplay from "../../../utils/FileDisplay";
import NuDateFormat from "../../../utils/NuDate";
import { ViewLabelwithDataBg } from "../../../components/View/ViewLabelwithData";

function ViewTaskDetails({ visible, onClose, data }) {
  if (!visible) return null;

  return (
    <div
      id="modal"
      className="bg-black bg-opacity-30 fixed inset-0 backdrop-blur-sm 
  flex justify-center items-center z-10"
    >
      <div className="bg-white p-2 rounded w-8/12 max-h-[calc(100vh-80px)] overflow-hidden">
        <div className="flex items-start justify-between px-5 py-2  rounded-t">
          <h3 className="text-base 2xl:text-xl capitalize font-semibold">
            Task View
          </h3>
          <span
            className="h-6 w-6 text-2xl block cursor-pointer"
            onClick={onClose}
          >
            <CloseIcon />
          </span>
        </div>
        <div className="overflow-y-auto max-h-[calc(100vh-140px)]">
          <div>
            <ViewLabelwithDataBg
              title="Task"
              value={
                data.task_id === 1
                  ? "Implementation Checklist"
                  : data.task_id === 2
                  ? "Internal Audit Checklist"
                  : data.task_id === 3
                  ? "Maintenance"
                  : data.task_id === 4
                  ? "Master List of Documents"
                  : data.task_id === 6
                  ? "Audit Schedule"
                  : data.task_id === 7
                  ? "Standard Document"
                  : data.task_id === 8
                  ? "Explanation of Standard"
                  : data.task_id === 9
                  ? "Benefits of standard"
                  : data.task_id === 10
                  ? "Calendar Management"
                  : data.task_id === 11
                  ? "Vendor Management"
                  : data.task_id === 12
                  ? "Security Incident"
                  : data.task_id === 13
                  ? "Abbreviations"
                  : data.task_id === 14
                  ? "Q & A Help"
                  : data.task_id === 15
                  ? "Diagrams / Logo's"
                  : data.task_id === 16
                  ? "Training Calendar"
                  : data.task_id === 17
                  ? "Agenda"
                  : data.task_id === 18
                  ? "CISO / MRM Meeting MoM"
                  : "-"
              }
            />
            <ViewLabelwithDataBg title="Title" value={data?.title || "-"} />
            <ViewLabelwithDataBg title="Status" value={data?.status || "-"} />
            <ViewLabelwithDataBg
              title="Comments"
              value={data?.comment || "-"}
            />
            <ViewLabelwithDataBg
              title="Completion Date"
              value={
                (data?.completion_date &&
                  data?.completion_date != "None" &&
                  data?.completion_date != null &&
                  NuDateFormat({
                    value: data?.completion_date,
                    format: "DD-MMM-yyyy",
                  })) ||
                "-"
              }
            />
            <ViewLabelwithDataBg
              title="Reminder Date"
              value={
                (data?.reminder_date &&
                  data?.reminder_date != "None" &&
                  data?.reminder_date != null &&
                  NuDateFormat({
                    value: data?.reminder_date,
                    format: "DD-MMM-yyyy",
                  })) ||
                "-"
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewTaskDetails;
